<template>
    <v-app >

      <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
        <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

          <v-container fluid fill-height align-start>
                <v-row >
                    <v-col md="12" lg="12" cols="12">

                        <v-alert
                                :value="alertborrador"
                                color="red"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Evento se borro con éxito.
                        </v-alert>
                        <v-alert
                                :value="alertnuevo"
                                color="primary"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Evento se agrego con éxito.
                        </v-alert>
                        <v-alert
                                :value="alerteditar"
                                color="green"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Evento se edito con éxito.
                        </v-alert>
                      <h1 class="text-h3 text-center" style="color: #393E46;">Mis Eventos</h1>
<br/>
                      <v-btn color="primary" dark class="mb-2" @click="irpaso1">Nuevo Evento</v-btn>
                      <div>
                        <v-switch label="Ver Como Tabla" v-model="vistatabla"></v-switch>
                      </div>
                      <v-dialog v-model="edialog" max-width="500px">
                        <v-card color="#393E46">
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field v-model="editedItem.nombre" label="Nombre"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-textarea v-model="editedItem.descripcion" label="Descripción" ></v-textarea>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="confdialog" max-width="500px">
                        <v-card color="#393E46">
                          <v-card-title>
                            <span class="headline">Configuración</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-switch v-model="editedItem.activo" @click="activaEvento(item)" ></v-switch>
                                </v-col>

                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogdelete" persistent max-width="350">
                        <v-card color="#393E46">
                          <v-card-title class="headline">Desea eliminar esta Evento?</v-card-title>
                          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="close">No</v-btn>
                            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialoguploadfoto"  persistent max-width="600">
                        <v-card color="#393E46">
                          <v-card-title class="headline">Flyer del Evento</v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col md="12" lg="12" cols="12">
                                <v-img :src="editedItem.foto"  />
                              </v-col>
                              <v-col md="12" lg="12" cols="12">
                                <v-file-input
                                    label="Subir Nuevo Flyer"
                                    accept="image/*"
                                    filled
                                    chips
                                    v-model="imagen"
                                    @change="onFileChange"
                                    prepend-icon="mdi-camera"
                                ></v-file-input>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="dialoguploadfoto=false">Cerrar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialoguploadcabecera"  persistent max-width="600">
                        <v-card color="#393E46">
                          <v-card-title class="headline">Cabecera del Ticket</v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col md="12" lg="12" cols="12">
                                <v-img :src="editedItem.cabecera"  />
                              </v-col>
                              <v-col md="12" lg="12" cols="12">
                                <v-file-input
                                    label="Subir Cabecera de Ticket"
                                    accept="image/*"
                                    filled
                                    chips
                                    v-model="imagen"
                                    @change="onFileCabeceraChange"
                                    prepend-icon="mdi-camera"
                                ></v-file-input>

                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="dialoguploadcabecera=false">Cerrar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialoguploadfooter"  persistent max-width="600">
                        <v-card color="#393E46">
                          <v-card-title class="headline">Subir Pie del Ticket</v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col md="12" lg="12" cols="12">
                                <v-img :src="editedItem.footer"  />
                              </v-col>
                              <v-col md="12" lg="12" cols="12">
                                <v-file-input
                                    label="Subir Pie de Ticket"
                                    accept="image/*"
                                    filled
                                    chips
                                    v-model="imagen"
                                    @change="onFileFooterChange"
                                    prepend-icon="mdi-camera"
                                ></v-file-input>

                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="dialoguploadfooter=false">Cerrar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog >
                      <v-dialog v-model="dialogcontactos" persistent max-width="600">
                        <v-card color="#393E46">
                          <v-card-title class="headline">Contactos del Evento</v-card-title>

                          <v-card-text>
                            <v-row>
                              <v-col>
                                <v-autocomplete
                                    v-model="SelectedEventoContacots"
                                    :items="EventoContactos"
                                    label="Contactos"
                                    item-text="contacto"
                                    item-value="id"
                                    multiple
                                    chips
                                    return-object
                                    hint="Elegir Contactos"
                                    persistent-hint
                                >
                                  <template v-slot:selection="data">
                                    <v-chip
                                        :input-value="data.item.id"
                                        close
                                        @click="data.select"
                                        @click:close="remove(data.item)"
                                    >
                                      {{ data.item.contacto }}
                                    </v-chip>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="blue darken-1" text @click="grabarcontactos">Grabar</v-btn>

                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="dialogcontactos=false">Cerrar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <div v-if="vistatabla===false">
                        <v-row>
                          <v-col cols="12" md="3" sm="12" lg="3"
                                 v-for="evento in Eventos" :key="evento.id"
                          >
                            <v-card color="#393E46"
                            >
                              <v-card-title>{{evento.nombre}}</v-card-title>
                              <v-card-subtitle>
                                <p>{{evento.eventoCategoria.eventoCategoria}}</p>
                                <v-switch v-model="evento.activo" @change="graba(evento)" label="Activo">Activo</v-switch>
                              </v-card-subtitle>
                              <v-card-text>
                                <v-row justify="center">
                                  <v-col lg="6" md="6" sm="12">
                                    <div v-if="evento.foto==''">
                                      <v-img height="200" src="@/assets/sinimagen.jpeg" />
                                    </div>
                                    <div v-else>
                                      <v-img height="200" :src="evento.foto"></v-img>
                                    </div>
                                  </v-col>
                                </v-row>
                                <v-row justify="ce  nter">
                                  <v-col cols="12" lg="12" align="center" >
                                    <h3> {{formatDatee(evento.fechaInicio)}}</h3>
                                  </v-col>
                                </v-row>

                              </v-card-text>
                              <v-card-actions>
                                <v-row>
                                  <v-col>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                    <v-icon

                                        color="primary"
                                        large
                                        class="mr-2"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="editItem(evento)"
                                    >
                                      fas fa-edit
                                    </v-icon>  </template>
                                      <span>Editar</span>
                                    </v-tooltip>
                                  </v-col>
                                  <v-col> <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">  <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                      class="mr-2"
                                      large
                                      color="error"
                                      @click="deleteItem(evento)"
                                  >
                                    fas fa-minus-circle
                                  </v-icon></template>
                                    <span>Borrar</span>
                                  </v-tooltip> </v-col>
                                  <v-col v-if="evento.eventoCategoria.id !== 8"> <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">  <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                      class="mr-2"
                                      large
                                      color="yellow"
                                      @click="fotoItem(evento)"
                                  >
                                    fas fa-camera-retro
                                  </v-icon></template>
                                    <span>Cambiar Foto</span>
                                  </v-tooltip>
                                  </v-col>
                                  <v-col><v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        color="#aad178"
                                        large
                                        class="mr-2"
                                        @click="configItem(evento)"
                                    >
                                      fas fa-cog
                                    </v-icon></template>
                                    <span>Configuración</span>
                                  </v-tooltip>
                                  </v-col>
                                 <v-col v-if="evento.eventoCategoria.id !== 8"><v-tooltip bottom>
                                   <template v-slot:activator="{ on, attrs }"><v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                      color="primary"
                                      large
                                      class="mr-2"
                                      @click="irEntradas(evento)"
                                  >
                                    fas fa-ticket-alt
                                  </v-icon></template>
                                   <span>Ver Entradas</span>
                                 </v-tooltip></v-col>
                                  <v-col v-if="evento.eventoCategoria.id !== 8"><v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }"><v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        color="primary"
                                        large
                                        class="mr-2"
                                        @click="irZona(evento)"
                                    >
                                      fas fa-vihara
                                    </v-icon></template>
                                    <span>Ver Zonas</span>
                                  </v-tooltip></v-col>
                                  <v-col ><v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      large
                                      color="white"
                                      class="mr-2"
                                      @click="contactosItem(evento)"
                                  >
                                    fas fa-people-carry
                                  </v-icon></template>
                                    <span>Contactos del Evento</span>
                                  </v-tooltip></v-col>
                                  <v-col v-if="evento.eventoCategoria.id !== 8"><v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }"> <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                      color="green"
                                      large
                                      class="mr-2"
                                      @click="cabeceraItem(evento)"
                                  >
                                    fas fa-hard-hat
                                  </v-icon></template>
<span>Cambiar Foto Cabecera Entradas</span>
</v-tooltip></v-col>
                                  <v-col v-if="evento.eventoCategoria.id !== 8"> <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }"> <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                      color="yellow"
                                      large
                                      class="mr-2"
                                      @click="footerItem(evento)"
                                  >
                                    fas fa-socks
                                  </v-icon></template>
                                    <span>Cambiar Pie de Foto Entradas</span>
                                  </v-tooltip></v-col>


                                </v-row>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>

                      <div v-else-if="vistatabla===true">
                      <v-data-table
                                :headers="headers"
                                :items="Eventos"
                                sort-by="Evento"
                                sort-desc
                                class="elevation-1"
                                :search="search"
                                :loading="progr"
                                no-data-text="No hay datos disponibles para mostrar."
                                no-results-text="No hay resultados para la búsqueda."
                                loading-text="Cargando... Por favor espere."
                                style="background-color: #393E46;"
                        >
                            <template v-slot:top>
                                <v-toolbar flat >
                                    <v-toolbar-title>Eventos</v-toolbar-title>
                                    <v-progress-circular
                                            indeterminate
                                            v-if="progr == true"
                                            color="primary"
                                    ></v-progress-circular>
                                    <v-divider
                                            class="mx-4"
                                            inset
                                            vertical
                                    ></v-divider>
                                    <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                                    <v-spacer></v-spacer>


                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <v-icon
                                        small
                                        color="blue"
                                        class="mr-2"
                                        @click="editItem(item)"
                                >
                                    fas fa-edit
                                </v-icon>
                                <v-icon
                                        small
                                        color="error"
                                        class="mr-2"
                                        @click="deleteItem(item)"
                                >
                                    fas fa-minus-circle
                                </v-icon>
                                <v-icon
                                        small
                                        color="#6ad2eb"
                                        class="mr-2"
                                        @click="editItem(item)"
                                >
                                    fas fa-pencil-ruler
                                </v-icon>
                                <v-icon
                                        small
                                        color="#f7be64"
                                        class="mr-2"
                                        @click="fotoItem(item)"
                                >
                                    fas fa-camera-retro
                                </v-icon>
                                <v-icon
                                        small
                                        color="#aad178"
                                        class="mr-2"
                                        @click="configItem(item)"
                                >
                                    fas fa-cog
                                </v-icon>
                            </template>
                            <template v-slot:[`item.zonas`]="{ item }">
                                <v-icon
                                        small
                                        color="primary"
                                        class="mr-2"
                                        @click="irZona(item)"
                                >
                                    fas fa-vector-square
                                </v-icon>

                            </template>
                            <template v-slot:[`item.tickets`]="{ item }">
                                <v-icon
                                        small
                                        color="primary"
                                        class="mr-2"
                                        @click="irEntradas(item)"
                                >
                                    fas fa-ticket-alt
                                </v-icon>
                                <v-icon
                                        small
                                        color="green"
                                        class="mr-2"
                                        @click="cabeceraItem(item)"
                                >
                                    fas fa-hard-hat
                                </v-icon>
                              <v-icon
                                  small
                                  color="yellow"
                                  class="mr-2"
                                  @click="footerItem(item)"
                              >
                                fas fa-socks
                              </v-icon>
                            </template>
                            <template v-slot:[`item.promotores`]="{ item }">
                                <v-icon
                                        small
                                        color="secondary"
                                        class="mr-2"
                                        @click="contactosItem(item)"
                                >
                                    fas fa-people-carry
                                </v-icon>

                            </template>
                            <template v-slot:[`item.activ`]="{ item }">
                                <v-switch v-model="item.activo" @click="activaEvento(item)" ></v-switch>
                            </template>
                          <template v-slot:[`item.fechai`]="{ item }">
                            {{formatDatee(item.fechaInicio)}}
                          </template>
                            <template v-slot:no-data>
                                <v-btn color="primary" @click="dameEventos">Cargar de Nuevo</v-btn>
                            </template>
                        </v-data-table>
                      </div>

                    </v-col>
                </v-row>
              <leftmenueventos :abreviado="abreviado" />
            <v-overlay :value="overlay">
              <v-img
                  src="@/assets/loadtunay.gif"

              />
            </v-overlay>
            </v-container>
        </v-main>
      <piepagina/>
    </v-app>
</template>
<script>
    import { mapGetters } from "vuex";
    import axios from 'axios';
    import moment from "moment";
    import piepagina from "@/components/general/piepagina";
    import Leftmenueventos from "@/components/general/leftmenueventos";
    import store from "@/store";
    import firebase from 'firebase/compat/app';
    import Cabecerabaja from "@/components/general/cabecerabaja";

    export default {
      title: 'Eventos | Tunay Mi acceso de bolsillo',

      components: {
        Cabecerabaja,
          Leftmenueventos,
          piepagina
        },
        data: () => ({
          vistatabla: false,
            drawer: null,
            overlay:false,
            progr: true,
          token:'',
            alertborrador: false,
            alertnuevo: false,
            alerteditar: false,
            dialog: false,
            categoriafiesta: 0,
            tipoevento: 0,
          abreviado:'NN',

          steps: 4,
            e1: 1,
            imagen:null,
            edialog: false,
            confdialog: false,
            dialogdelete: false,
            dialogcontactos: false,
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            dialoguploadfooter: false,
            dialoguploadcabecera: false,
            dialoguploadfoto: false,
            menu1: false,
            menu2: false,
            menu3: false,
            modal3: false,
            modal4: false,
            menu4: false,
            time: null,
            time2: null,
            Eventos: [],
            CategoriaEventos: [],
            TipoEventos: [],
            eventoId: 0,
            EventoContactos:[],
            SelectedEventoContacots:[],
            search: '',
            editedIndex: -1,
            contactoEventoItem: {
              contactoEventoId:0,
              contactoDTO:{
                contactoId:0,
                contactoNombre:''
              },
              eventoDTO:{
                eventoId:0,
                eventoNombre:'',
                eventoTag:''
              }
            },
            editedItem: {
              activo: false,
              aforo: 0,
              cabecera: "",
              cliente: {},
              contactoEntitySet: [],
              createdAt: null,
              descripcion: "",
              eventoCategoria: {},
              fechaFinal: "2017-10-21",
              fechaInicio: "2017-10-21",
              flyer: "",
              footer: "",
              foto: "",
              horaFinal: "00:00:00",
              horaInicio: "00:00:00",
              id: 1,
              lat: "",
              listaapp: false,
              lng: "",
              nombre: "",
              promotorcambia: false,
              publicoapp: false,
              qrmail: false,
              tag: "",
              tipoEvento: {},
              ubicacion: "",
              ventapp: false,
            },
            defaultItem: {
              activo: false,
              aforo: 0,
              cabecera: "",
              cliente: {},
              contactoEntitySet: [],
              createdAt: null,
              descripcion: "",
              eventoCategoria: {},
              fechaFinal: "2017-10-21",
              fechaInicio: "2017-10-21",
              flyer: "",
              footer: "",
              foto: "",
              horaFinal: "00:00:00",
              horaInicio: "00:00:00",
              id: 1,
              lat: "",
              listaapp: false,
              lng: "",
              nombre: "",
              promotorcambia: false,
              publicoapp: false,
              qrmail: false,
              tag: "",
              tipoEvento: {},
              ubicacion: "",
              ventapp: false,
            },
            headers: [
                { text: 'Acciones', value: 'action', sortable: false },
                { text: 'Zonas', value: 'zonas', sortable: false },
                { text: 'Tickets', value: 'tickets', sortable: false },
                { text: 'Contactos', value: 'promotores', sortable: false },
                { text: 'Evento', align: 'left',  value: 'nombre'},
                { text: 'Fecha', value: 'fechai' },
                { text: 'Activo', value: 'activ', sortable: false }

            ]
        }),
        mounted (){
          if(this.cliente == null){
            this.$router.push({ name: 'creacliente' });
          }else{
          if (this.cliente.id > 0){
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            this.dameEventos();
            this.dameCategoriasEventos();
            this.dameTiposEventos();
            this.todoscontactos(this.usuario.id)
            this.editedItem.fechaInicio = this.formatDate(this.date);
            this.editedItem.fechaFinal = this.formatDate(this.date2);
            this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
          }else{
            this.$router.push({ name: 'creacliente' });
          } }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            date () {
                this.editedItem.fechaInicio = this.formatDate(this.date)
            },
            date2 () {
                this.editedItem.fechaFinal = this.formatDate(this.date2)
            },
        },
        methods : {
          formatDatee(value) {
            return moment(value).locale('es-pe').format("DD MMMM YYYY")
          },
          remove (item) {
            const index = this.SelectedEventoContacots.indexOf(item)
            if (index >= 0) this.SelectedEventoContacots.splice(index, 1)
          },
            dameEventos(){
              this.overlay = true;
                this.progr = true;
                let urlEvento = 'eventos/cliente/' + this.cliente.id ;
                axios
                    .get(urlEvento,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.Eventos = response.data;
                        this.progr = false;
                        this.alertborrador = false;
                        this.alertnuevo = false;
                        this.alerteditar = false;
                        this.overlay = false;
                    })
                    .catch((error)  => {
                        console.log(error);
                      this.progr = false;
                    });
            },
          formatDate (date) {
            return moment(date).locale('es-pe').format("YYYY-MM-DD");
          },
          formatDatree(value) {
            return moment(value).locale('es-pe').format("DD-MM-YYYY")
          },
          irpaso1(){
            this.$router.push({name:'CreaPaso1'});
          },
          formatTime (date) {
            let hora = new Date('2020-10-10 '+date)
            return moment(hora).locale('es-pe').format("HH:mm");
          },
            parseDate (date) {
                if (!date) return null

                const [day,month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
          onFileFooterChange(e) {
            this.editedItem.footer= URL.createObjectURL(this.imagen)
            var bodyFormData = new FormData();
            bodyFormData.append("file",this.imagen);
            let url = "eventos/footer/" + this.editedItem.eventoId
            this.overlay = true
            axios
                .post(url,bodyFormData,{
                  headers: {
                    'Authorization': `Bearer ${this.token}`,
                  }
                })
                .then(response => {
                  console.assert(true,response);
                  this.dialoguploadfooter = false;
                  this.overlay = false
                })
                .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
            console.log(e)
          },
          onFileChange(e) {
            this.editedItem.foto= URL.createObjectURL(this.imagen)
            var bodyFormData = new FormData();
            bodyFormData.append("file",this.imagen);
            let url = "eventos/foto/" + this.editedItem.id
            this.overlay = true
            axios
                .post(url,bodyFormData,{
                  headers: {
                    'Authorization': `Bearer ${this.token}`,
                  }
                })
                .then(response => {
                  console.assert(true,response);
                  this.dialoguploadfoto = false;
                  this.overlay = false
                })
                .catch(error => {
                  this.error = "Hubo un error";
                  console.log(error);
                });
            console.log(e)
          },
          onFileCabeceraChange(e) {
            this.editedItem.cabecera= URL.createObjectURL(this.imagen)
            var bodyFormData = new FormData();
            bodyFormData.append("file",this.imagen);
            let url = "eventos/cabecera/" + this.editedItem.id
            this.overlay = true
            axios
                .post(url,bodyFormData,{
                  headers: {
                    'Authorization': `Bearer ${this.token}`,
                  }
                })
                .then(response => {
                  console.assert(true,response);
                  this.dialoguploadcabecera = false;
                  this.overlay = false
                })
                .catch(error => {
                  this.error = "Hubo un error";
                  console.log(error);
                });
            console.log(e)
          },
            dameCategoriasEventos(){
                this.progr = true;
                axios
                    .get('eventocategorias',{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.CategoriaEventos = response.data;
                        this.progr = false;
                        this.alertborrador = false;
                        this.alertnuevo = false;
                        this.alerteditar = false;
                    })
                    .catch((error)  => {
                        console.log(error);
                    });
            },
            dameTiposEventos(){
                this.progr = true;
                axios
                    .get('tipoeventos',{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.TipoEventos = response.data;
                        this.progr = false;
                        this.alertborrador = false;
                        this.alertnuevo = false;
                        this.alerteditar = false;
                    })
                    .catch((error)  => {
                        console.log(error);
                    });
            },
            activaEvento (item) {
                this.editedItem = Object.assign({}, item)
              this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
              this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
              var bodyFormData2 = new FormData();
                bodyFormData2.append("data",JSON.stringify(this.editedItem));
                axios
                    .post('eventos/grabaevento',bodyFormData2,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    }).then(response => {
                    console.log(response);
                     })
                    .catch(error => {
                        this.error = "Hubo un error";
                        console.log(error);
                    });
            },
            editItem (item) {
                this.editedIndex = this.Eventos.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.edialog = true
            },
            cabeceraItem(item){
              this.editedIndex = this.Eventos.indexOf(item)
              this.editedItem = Object.assign({}, item)
              this.dialoguploadcabecera = true
            },
          footerItem(item){
            this.editedIndex = this.Eventos.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialoguploadfooter = true
          },
          contactosItem(item){
            this.editedIndex = this.Eventos.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogcontactos = true
            this.contactosevento(this.editedItem.id)
          },
          fotoItem(item){
            this.editedIndex = this.Eventos.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialoguploadfoto = true
          },
          todoscontactos(idcliente){
            let url = 'contactos/cliente/'+idcliente
            this.progr = true
            this.overlay = true

            axios
                .get(url,{
                  headers: {
                    'Authorization': `Bearer ${this.token}`,
                  }
                })
                .then(response => {
                  this.EventoContactos = response.data
                  this.progr = false;
                  this.alertborrador = false;
                  this.alertnuevo = false;
                  this.alerteditar = false;
                  this.overlay = false

                })
                .catch((error)  => {
                  console.log(error);
                  this.overlay = false

                });
          },
          contactosevento(idevento){
            this.eventoId = idevento
            let url = 'contactos/evento/'+idevento
            this.progr = true
            this.overlay = true
            axios
                .get(url,{
                  headers: {
                    'Authorization': `Bearer ${this.token}`,
                  }
                })
                .then(response => {
                  let contactosselected = response.data;
                  this.SelectedEventoContacots = [];

                  for( var x of contactosselected){
                    let obj = {
                      'id' : x.id,
                      'contactoNombre' : x.contactoNombre
                    }
                    this.SelectedEventoContacots.push(obj)
                  }
                  this.progr = false;
                  this.alertborrador = false;
                  this.alertnuevo = false;
                  this.alerteditar = false;
                  this.overlay = false

                })
                .catch((error)  => {
                  console.log(error);
                  this.overlay = false

                });
          },
          grabarcontactos(){
            let contactoseventos = [];
            this.overlay = true

            for( var x = 0 ; x<this.SelectedEventoContacots.length; x++){
              let obj = {
                  'id' : this.SelectedEventoContacots[x].id,
                  'contacto' : this.SelectedEventoContacots[x].contacto
                }


              contactoseventos.push(obj)
            }
            var bodyFormData2 = new FormData();
            bodyFormData2.append("data",JSON.stringify(contactoseventos));
            bodyFormData2.append("eventoId",this.eventoId);

            axios
                 .post('eventos/contactos/grabar',bodyFormData2,{
                   headers: {
                     'Authorization': `Bearer ${this.token}`,
                   }
                 }).then(response => {
                  console.log(response)
                  this.dialogcontactos = false
              this.overlay = false
            })
                .catch(error => {
                  this.error = "Hubo un error";
                  console.log(error);
                  this.overlay = false

                });
          },
            configItem (item) {
                this.editedIndex = this.Eventos.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.confdialog = true
            },
            deleteItem (item) {
                this.editedIndex = this.Eventos.indexOf(item);
                this.dialogdelete = true;
            },
           irZona(item){
             this.editedIndex = this.Eventos.indexOf(item);
             this.editedItem = Object.assign({}, item)
             store.dispatch("fetchEvento", this.editedItem);

             this.$router.push({name:'ZonaEvento'})
           },
          irEntradas(item){
            this.editedIndex = this.Eventos.indexOf(item);
            this.editedItem = Object.assign({}, item)
            store.dispatch("fetchEvento", this.editedItem);
            this.$router.push({name:'TicketEvento'})
          },
            borralo (){
             let idevento = this.Eventos[this.editedIndex].id
                axios
                    .delete('eventos/'+idevento,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.dialogdelete = false;
                        this.alertborrador = true;
                        this.Eventos = response.data
                    })
                    .catch(error => {
                        this.error = "Hubo un error";
                        console.log(error);
                    });
            },
            close () {
                this.dialog = false;
                this.edialog = false;
                this.confdialog = false;
                this.dialogdelete = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },
          graba(item){
            var bodyFormData2 = new FormData();
            item.fechaInicio = this.formatDatree(item.fechaInicio)
            item.fechaFinal = this.formatDatree(item.fechaFinal)
            bodyFormData2.append("data",JSON.stringify(item));
            axios
                .post('eventos/grabaevento',bodyFormData2,{
                  headers: {
                    'Authorization': `Bearer ${this.token}`,
                  }
                }).then(response => {
              this.Eventos = response.data
              this.alerteditar = true;

            })
                .catch(error => {
                  this.error = "Hubo un error";
                  console.log(error);
                });
          },
            save () {
              var bodyFormData2 = new FormData();
                if (this.editedIndex > -1) {
                    Object.assign(this.Eventos[this.editedIndex], this.editedItem);
                  this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
                  this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
                  this.editedItem.horaInicio = this.formatTime(this.editedItem.horaInicio)
                  this.editedItem.horaFinal = this.formatTime(this.editedItem.horaFinal)
                  bodyFormData2.append("data",JSON.stringify(this.editedItem));

                  axios
                        .post('eventos/grabaevento',bodyFormData2,{
                          headers: {
                            'Authorization': `Bearer ${this.token}`,
                          }
                        }).then(response => {
                        this.Eventos = response.data
                        this.alerteditar = true;

                    })
                        .catch(error => {
                            this.error = "Hubo un error";
                            console.log(error);
                        });
                } else {
                  this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
                  this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
                  this.editedItem.horaInicio = this.formatTime(this.editedItem.horaInicio)
                  this.editedItem.horaFinal = this.formatTime(this.editedItem.horaFinal)
                  bodyFormData2.append("data",JSON.stringify(this.editedItem));

                  axios
                        .post('eventos/grabaevento',bodyFormData2,{
                          headers: {
                            'Authorization': `Bearer ${this.token}`,
                          }
                        }).then(response => {
                        this.dameEventos();
                        this.alertnuevo = true;
                        console.log(response);
                    })
                        .catch(error => {
                            this.error = "Hubo un error";
                            console.log(error);
                        });
                }
                this.close()
            },
        },
        computed: {
            // map `this.user` to `this.$store.getters.user`
            formTitle () {
                return this.editedIndex === -1 ? 'Nueva Evento' : 'Editar Evento'
            },
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
            ...mapGetters({
                user: "user",
                usuario: "usuario",
              cliente: "cliente"
            })
        }
    };
</script>
